import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const ModalStyled = styled.div.attrs({
  className: 'ModalStyled',
})`
  .component__modal {
    .modal__wrapper {
      justify-content: center;
      align-items: center;

      .modal__dialog {
        width: calc(100% - 2.5rem);
        max-width: ${({ maxWidth }) => maxWidth}rem;
        padding: 1.5rem;
        overflow-y: auto;

        >button:first-child {
          display: none;
        }
      }
    }
  }
`;

export const Header = styled.div`
  align-items: top;
  display: flex;
  justify-content: space-between;

  .Title {
    font-size: 1.5rem;
    color: ${themed('primary.text')};
    padding-right: 2rem;
    margin-bottom: 0.875rem;
  }

  svg {
    cursor: pointer;
    height: 1.25rem;
    width: 1.25rem;
  }
`;

export const ButtonGroup = styled.div.attrs({
  className: 'ButtonGroup',
})`
  display: flex;
  justify-content: space-between;

  .component__button {
    font-size: 1rem;
    width: calc(50% - 0.5rem);

    &:first-child {
      color: ${themed('primary.main')};
      border: solid 2px ${themed('primary.main')};
    }
  }
`;
